var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77532 19.0007L15.367 12.409L13.6753 10.7173L8.74616 15.6465L6.29616 13.1965L4.63366 14.859L8.77532 19.0007ZM3.00033 23.6673C2.35866 23.6673 1.80955 23.439 1.35299 22.9825C0.895659 22.5252 0.666992 21.9757 0.666992 21.334V2.66732C0.666992 2.02565 0.895659 1.47615 1.35299 1.01882C1.80955 0.562262 2.35866 0.333984 3.00033 0.333984H12.3337L19.3337 7.33398V21.334C19.3337 21.9757 19.1054 22.5252 18.6488 22.9825C18.1915 23.439 17.642 23.6673 17.0003 23.6673H3.00033ZM11.167 8.50065V2.66732H3.00033V21.334H17.0003V8.50065H11.167Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTask);
export default __webpack_public_path__ + "static/media/icon_task.5336e139fca838aa2086dfb6da47cdc2.svg";
export { ForwardRef as ReactComponent };